import { Box } from '@mui/system';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkDailySessionNoteSign } from 'src/redux/actions/documentationAction';
import { getAccessToken } from 'src/routes/AuthContext';
import { getSignatureTemplateUrl } from 'src/utils/jotform-functions';

type Props = {
  keys: any;
  formSubmissionUuid: string
};

const DailyNoteSignature = (props: Props) => {
  const { keys, formSubmissionUuid } = props;
  const dispatch = useDispatch();
  const getSubmissionId = useSelector((state: any) => state.submitEsignReducer);

  const [iframeRef, setIframeRef] = useState<any | null>(null);

  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        const response = await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  useEffect(() => {
    return () => {
      dispatch(
        checkDailySessionNoteSign({
          formSubmissionId: formSubmissionUuid,
        })
      );
    };
  }, []);

  return (
    <>
      {' '}
      {
        <Box
          // p={3}
          sx={{ height: '100%', width: '100%' }}
        >
          <iframe
            src={getSignatureTemplateUrl(keys)}
            width={'100%'}
            ref={updateIFrameRef}
            height={'100%'}
            style={{ border: 'none' }}
            title="sign doc"
          />
        </Box>
      }
    </>
  );
};

export default DailyNoteSignature;
